import { Divider } from "@blueprintjs/core"
import { HasId, ID } from "src/libs/interfaces/layouts"
import { HISTORY_TYPE, IHistoryStep, ILandingSection, SECTION_DESIGN_TYPE, TAB_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import CW, { ICarouselNavigation } from "./carousel-widget"
import updateHistory from "./utils/updateHistory"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"


/* Protopia Ecosystem component */
export interface ITabsWidgetProps {
   sectionId: ID
}
const TabsWidget = ({sectionId, ...props}: ITabsWidgetProps): JSX.Element => {
    const currentLanding    = useLandingStore((state: ILandingStore) => state.currentLanding)
    const section           = currentLanding.sections.find( (section: HasId) => section.id === sectionId )  
    
 
    const onChange = ( tabs_design_type: TAB_DESIGN_TYPE ) => {
        const prevData          = JSON.parse( JSON.stringify( section ) )
        const newSection: any   = { 
            ...section, 
            tabs_design_type:  tabs_design_type, 
        } 
        const historyStep: IHistoryStep = {
            data:  newSection,
            prevData,
            type: HISTORY_TYPE.SECTION,
            title : "Update section's tabs design layout",
        }
        const newLanding = {
            ...currentLanding,
            sections: currentLanding.sections.map((sec: ILandingSection) => {
                if(sec.id === sectionId ) {
                    return newSection
                }
                return sec
            })
        }  
        updateHistory( historyStep, newLanding ) 
    }

    return [ SECTION_DESIGN_TYPE.TABS ].includes( section.designType )
        ?
        <>
            <div className="pl-4 pr-2 max-width-400"> 
                <FieldInput
                    type={ SCALAR_TYPES.IMAGE_RADIO_CAROUSEL } 
                    values={  Object.values( TAB_DESIGN_TYPE ).map(v => ({ _id:v, title: __( v ), img: `/assets/img/landing/tabs_${v}.svg`,  height: 45,  })) }
                    value={ section.tabs_design_type }
                    editable
                    notClear
                    stepSize={ 2 }
                    onChange={ onChange }
                />
            </div>  
            <Divider  />
        </>
        :
        <></>
}
export default TabsWidget
 